// extracted by mini-css-extract-plugin
export var leftAlign = "_1n-2";
export var popper = "_1n-0";
export var subtitle = "_1n-1";